import "@popperjs/core";
import tippy from "tippy.js";
// The module build ships its stylesheet separately, and it carries the box radius,
// the arrow, and the transition the default animation uses.
import "tippy.js/dist/tippy.css";

// Sparkle's legacy tooltip code (`Sparkle.Tooltips.add` →
// `tippy(element, ...)`) references `tippy` as a bare global. The npm
// package only exports a default; expose it on window so the legacy code
// keeps working.
window.tippy ??= tippy;
